<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    :labelColsMd="labelColsMd"
    :contentColsMd="contentColsMd"
    name="description"
    :label="'Description'|pgettext('BillingDateRule')"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="description"
      v-model="item.description"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    :labelColsMd="labelColsMd"
    :contentColsMd="contentColsMd"
    name="anchor"
    :label="'Anchor date'|pgettext('BillingDateRule')"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect
      name="anchor"
      v-model="item.anchor"
      :options="anchorOptions"
      valueField="value"
      textField="name"
      required
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    :labelColsMd="labelColsMd"
    :contentColsMd="contentColsMd"
    name="offset_days"
    :label="'Offset'|pgettext('BillingDateRule')"
    :labelAlign="labelAlign"
    contentClass="input-group"
  >
    <div
      class="input-group-prepend"
    >
      <div
        class="input-group-text"
      >
        <input
          type="checkbox"
          v-model="isOffsetDaysSet"
          :disabled="!editing"
          @change="evh_3322283983417540_change($event, {})"
        >
        </input>
      </div>
    </div>
    <ItpFormInput
      type="number"
      name="offset_days"
      v-model="item.offset_days"
      :disabled="!isOffsetDaysSet"
      ref="offsetDays"
    >
    </ItpFormInput>
    <DIV
      class="input-group-append"
    >
      <span
        class="input-group-text"
      >
        {{ 'day'|pgettext('InputGroupAddon') }}
      </span>
    </DIV>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BillingDateRule extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onCheckChanged(...args: any[]) {
    if (this.isOffsetDaysSet) {
      this.setData('item.offset_days', 0);
    }
    else {
      this.setData('item.offset_days', null);
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Boolean,
  })
  editing!: boolean;

  @Watch('editing')
  onEditing(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editing")
  }

  @Prop({
    default: 3,
  })
  labelColsMd!: any;

  @Watch('labelColsMd')
  onLabel_cols_md(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelColsMd")
  }

  @Prop({
    default: 9,
  })
  contentColsMd!: any;

  @Watch('contentColsMd')
  onContent_cols_md(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contentColsMd")
  }

  metadata!: any;

  async $$load_metadata() {
    return this.$app.repo.get('ui_metadata')
  }

  labelAlign!: any;
  isOffsetDaysSet!: any;

  async $$load_isOffsetDaysSet() {
    return this.item.offset_days != null
  }

  ux!: any;
  dataMembers = ['metadata', 'labelAlign', 'isOffsetDaysSet', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        metadata: null,
        labelAlign: "right",
        isOffsetDaysSet: null,
        ux: null,
      },
    }
  }

  get anchorOptions() {
    if (this.loaded) {

      return this.metadata.billing_date_rule_anchor_options
    }
    return null;
  }

  get target() {
    if (this.loaded) {

      return this.item
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_3322283983417540_script_2278_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3322283983417540_script_2278, alias=undefined
    this.$nextTick(() => this.onCheckChanged(this.isOffsetDaysSet))
  }

  async act_3322283983417540_script_2278_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3322283983417540_script_2278, alias=undefined
    return {
      value: () => this.act_3322283983417540_script_2278_getActionArgs_value($event),
    }
  }

  async evh_3322283983417540_change(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3322283983417540_change.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_2276: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_2275: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_3322283983417540_script_2278: actions.ScriptAction;
    evh_3322283983417540_change_2277: actions.EventHandlerImpl;
    evh_3322283983417540_change: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_2276 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_2275 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_2276,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_2275],
      }
    );
    const act_3322283983417540_script_2278 = new actions.ScriptAction(
      {
        actionArgs: this.act_3322283983417540_script_2278_getActionArgs,
        events: [],
      }
    );
    const evh_3322283983417540_change_2277 = new actions.EventHandlerImpl(
      {
        action: act_3322283983417540_script_2278,
        event: "change",
        displayName: "script",
      }
    );
    const evh_3322283983417540_change = new actions.EventHandlerGroup(
      {
        handlers: [evh_3322283983417540_change_2277],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_2276,
      evh_7315092382398562_reload_2275,
      evh_7315092382398562_reload,
      act_3322283983417540_script_2278,
      evh_3322283983417540_change_2277,
      evh_3322283983417540_change,
    }
  }
}

Vue.component("BillingDateRule", BillingDateRule);

</script>